/** saves operators
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_transfersbeneficiaries
*/
export const SAVE_BENEFICIARIES_LIST = (state, payload) => {
    state.beneficiariesList = payload
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
    state.beneficiariesList = []
}
